import type { ICard } from "../../cardsSlice";

export const major0Card: ICard = {
    id: "major_0",
    arcana: "major",
    number: 0,
    suit: "major",
    court: "major",
    name: "Шут",
    nameEn: "The Fool",
    keywords: ["Невинность", "Свобода", "Спонтанность"],
    symbolism: [
      "Юноша шагает к краю обрыва",
      "Узелок на палке",
      "Белый цветок",
      "Маленькая собака",
      "Горы на горизонте"
    ],
    symbolismInterpretation: "Открытость, доверие к жизни, шаг в неизвестность без страха",
    archetype: "Первозданное 'я', чистый потенциал, начало духовного пути",
    psychology: "Спонтанность, готовность к новому, отказ от предвзятых ожиданий",
    upright: {
      personality: "Искренность, свобода, открытость опыту",
      relationships: "Свежий взгляд, спонтанные связи, отсутствие ограничений",
      work: "Начало нового, риск, оригинальные идеи",
      spirituality: "Открытое сердце, доверие к интуиции",
      examples: ["Переход в новое", "Открытие возможностей", "Выбор без гарантий"]
    },
    reversed: {
      meaning: "Безрассудство, утрата связи с реальностью, инфантильность",
      nuances: "Неподготовленность к последствиям, избегание ответственности"
    },
    associations: ["Пустота", "Зарождение", "Игра", "Наивность", "Духовный поиск"],
    combinations: [
      "С Колесницей — движение вперёд, импульс",
      "С Дьяволом — легкомыслие, уход от реальности"
    ],
    readingTips: [
      "Не путать свободу с отсутствием ответственности",
      "Оценить, поддерживается ли энергия Шута другими картами"
    ],
    selfQuestions: ["Где я боюсь начать новое?", "Где мне стоит рискнуть, чтобы расти?"]
  };


